import React from "react";

const NotificationBell = props => (
  <svg viewBox="0 0 19 21" fill="none" {...props}>
    <path
      d="M9.75 19.25c-.703 0-1.25-.547-1.25-1.25H7.25c0 1.406 1.094 2.5 2.5 2.5 1.367 0 2.5-1.094 2.5-2.5H11c0 .703-.586 1.25-1.25 1.25zm8.164-5.664C16.82 12.57 16 11.476 16 7.766c0-3.086-2.5-5.625-5.625-5.938v-.703c0-.313-.313-.625-.625-.625a.642.642 0 00-.625.625v.703c-3.164.313-5.664 2.852-5.664 5.938 0 3.71-.82 4.804-1.914 5.82a1.878 1.878 0 00-.43 2.031c.274.703.977 1.133 1.758 1.133h13.75c.742 0 1.445-.43 1.719-1.133a1.878 1.878 0 00-.43-2.031zM16.625 15.5H2.875c-.586 0-.86-.625-.469-1.016 1.367-1.289 2.305-2.734 2.305-6.718C4.71 5.148 6.977 3 9.75 3c2.734 0 5 2.148 5 4.766 0 3.984.938 5.43 2.305 6.718.39.391.117 1.016-.43 1.016z"
      fill="currentColor"
    />
  </svg>
);

export default NotificationBell;
